import React from "react";

export default function RulesDialog(props) {
  const { open, setOpen } = props;

  const handleClose = () => {
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="bottom-sheet-overlay" onClick={handleClose}>
      <div className="bottom-sheet-paper" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="history-modal-header">
          <div style={{ width: "36px" }} />
          <h2 className="history-modal-title">Rules</h2>
          <button className="history-modal-close" onClick={handleClose}>
            ✕
          </button>
        </div>

        {/* Content */}
        <div className="bottom-sheet-content">
          <div className="rules-list">
            <div className="rule-item">
              <h3 className="rule-title">1. Betting</h3>
              <p className="rule-desc">
                Select the chip amount you want to bet, then tap your desired fruit box. Winning bets receive 3× the bet amount.
              </p>
            </div>

            <div className="rule-item">
              <h3 className="rule-title">2. Time Limit</h3>
              <p className="rule-desc">
                The betting period is 20 seconds in each round.
              </p>
            </div>

            <div className="rule-item">
              <h3 className="rule-title">3. Betting Limits</h3>
              <p className="rule-desc">
                You can bet on all available fruits in each round.
              </p>
            </div>

            <div className="rule-item">
              <h3 className="rule-title">4. Interpretation</h3>
              <p className="rule-desc">
                Streamfy reserves all rights to interpret the rules of this event.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
